import React from 'react';
import styled from 'styled-components';
import Confetti from 'react-confetti';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
  max-width: 60%;
  width: 90%;
  font-size: xxx-large;
`;

const CloseButton = styled.button`
  padding: 0.5rem 1rem;
  margin-top: 1rem;
  cursor: pointer;
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 4px;
`;

const PrizeInfo = styled.div`
    margin: 1rem 0;
`;

const RemainingPrizes = styled.p`
    color: #666;
    font-size: 1.5rem;
    margin-top: 1rem;
`;

const WinningModal = ({ prize, remainingPrizes, onClose }) => {
    return (
        <ModalOverlay>
            <Confetti
                width={window.innerWidth}
                height={window.innerHeight}
                recycle={false}
                numberOfPieces={200}
            />
            <ModalContent>
                <h1>🎉 Chúc mừng! 🎉</h1>
                <PrizeInfo>
                    <p>Bạn đã trúng: <strong>{prize}</strong></p>
                    <RemainingPrizes>
                        {remainingPrizes > 0
                            ? `Còn ${remainingPrizes} phần thưởng trong vòng quay`
                            : 'Đã hết phần thưởng trong vòng quay!'
                        }
                    </RemainingPrizes>
                </PrizeInfo>
                <CloseButton onClick={onClose}>Đóng</CloseButton>
            </ModalContent>
        </ModalOverlay>
    );
};

export default WinningModal; 